<template lang="html">
  <app-modal @close="close" class="add-crop">
    <app-modal-default @close="close">
      <template v-slot:header>
        {{$ml.get(`Add crops`)}}
      </template>
      <template v-slot:content>
        <div class="body">
          <p class="title">
            {{$ml.get(`You cannot remove the crop later, so be careful`)}}
          </p>
          <SearchInput delayed v-model="search" @input="sync"/>
          <app-loading :loading="get_loading">
            <div class="items scroller">
              <div
                class="item"
                v-for="item in crops"
                @click="selectCrop(item)"
                :class="{ selected: item.id === selected.id }"
                v-if="item.owner == 0"
              >
              <!-- TODO проверить перевод -->
              <p class="name" v-if="$ml.get(item.name)">{{item.name}} ({{ $ml.get(item.name) }})</p>
              <p class="name" v-else>{{ item.name }}</p>

              <p class="type" v-if="item.type == 'soil-grown'">{{ $ml.get(`Soil-grown`) }}</p>
              <p class="type" v-else>{{ $ml.get(`Hydroponic`) }}</p>
            </div>
            </div>
          </app-loading>
          <app-btn
            :loading="get_loading"
            :disabled="!selected.id"
            @click="addCrop"
          >
            {{$ml.get(`add`)}}
          </app-btn>
        </div>
      </template>
    </app-modal-default>
  </app-modal>
</template>

<script>
import SearchInput from '@/components/common/SearchInput';
import { mapGetters } from 'vuex';
import { CropAPI } from '@/api';

export default {
  data() {
    return {
      items: [],
      selected: {},
      search: '',
      get_loading: false,
      add_loading: false,
    }
  },
  components: {
    SearchInput,
  },
  methods: {
    close() {
      this.$store.commit('modals/add-crop/close');
    },
    sync() {
      this.get_loading = true;
      return CropAPI.getAllCrops({
        take: 1000,
        page: 0,
        search: this.search,
      }).then(res => {
        this.items = res.data.data;
      }).finally(() => {
        this.get_loading = false;
      });
    },
    async addCrop() {
      this.add_loading = true;
      await CropAPI.addToCrops(this.selected.id).then(res => {
        this.$notify({
          group: 'notices',
          title: 'You added crop to your list',
          type: 'success',
        });
        
      }).catch(err => {
        console.log();
        this.$notify({
          group: 'notices',
          title: err.response.data.err,
          type: 'error',
        });
      });
      await this.$store.dispatch('user-crops/updateData');
      this.add_loading = false;
      this.selected = {};

      this.close();
    },
    selectCrop(item) {
      this.selected = item
    }
  },
  created() {
    this.sync();
  },
  computed: {
    ...mapGetters({
      userCrops: 'user-crops/data'
    }),
    crops() {
      return this.items.filter(n => !this.userCrops.find(z => n.id === z.id))
    }
  }
}
</script>

<style lang="scss" scoped>

::v-deep {
  .app-modal-default .content {
    padding-left: 0;
    padding-right: 0;
  }
}

.body {
  min-width: 300px;
  max-width: 400px;
  height: 80vh;
  display: flex;
  flex-direction: column;
  align-items: center;

  .app-loading {
    min-height: 200px;
  }

  .title {
    padding:0 20px 20px;
    // padding-top: 0;
    text-align: center;
    font-family: 'Roboto', sans-serif;
    font-size: 16px;
    font-weight: bold;
    margin: 0;
  }

  .items {

    // display: flex;
    // flex-direction: column;
    // align-items: stretch;

    max-width: 100%;
    padding: 20px;
    margin: 5px 3px 16px;
    overflow-y: auto;

    .item {
      // min-height: 50px;
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      text-transform: capitalize;
      border-left: 2px solid transparent;
      // padding-left: 10px;
      cursor: pointer;
      border-bottom: 1px solid #e0e0e0;
      padding: 16px 16px 10px 16px;
      &:first-child {
        border-top: 1px solid #e0e0e0;
      }
      &.selected {
        border-left: 2px solid $mainGreen;
        color: $mainGreen;
        // font-weight: bold;
      }
      p {
        margin: 0;
        &.name {
          margin-bottom: 8px;
          font-size: 18px;
          font-weight: bold;
          word-wrap: break-word;
        }
        &.type {
          font-size: 12px;
          color: #8B8D91;
        }
      }
    }
  }

  .search-input {
    width: calc(100% - 40px);
    margin: 0 20px;
  }

  .app-sel {
    width: 100%;
    margin-bottom: 30px;
  }

  .btn {
    margin-right: 20px;
  }
}

</style>
